import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import * as yup from "yup";
import { Formik, ErrorMessage } from "formik";
import Form from "react-bootstrap/Form";
// import { Link } from "react-scroll";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Layout from "../Components/Layout";
import { ContactUs, landingPage } from "../Redux/Actions/UserActions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import UserCountdown from "../Components/UserCountDown";

const validateYupSchema = yup.object().shape({
  name: yup.string().required(<span style={{ color: "red" }}>Required</span>),
  email: yup
    .string()
    .email(<span style={{ color: "red" }}>Invalid Email Address</span>)
    .required(<span style={{ color: "red" }}>Required</span>),
  message: yup
    .string()
    .required(<span style={{ color: "red" }}>Required</span>),
});

export default function Home() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.landingpageadata.data);
  console.log(data);

  // ===================================landing page content api=========================================================

  useEffect(() => {
    dispatch(landingPage());
  }, []);

  AOS.init();
  const optionsnewslider = {
    slidesToShow: 1,
    autoplay: true,
    dots: true,
    nav: false,
    smartSpeed: 1000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 3,
      },
      700: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  };

  const optionsslider = {
    centerMode: true, // Centers the slide items
    centerPadding: "0px", // Adjust padding as needed
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    stagePadding: 10,
    smartSpeed: 1000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);
  return (
    <Layout>
      <section className="banner_section" id="home">
        <Container>
          <Row>
            <Col
              lg={6}
              className=""
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div className="banner_text">
                <h1>
                  <span className="green_color"> Get Your </span> <br />
                  Tasks Completed By
                  <br />
                  Trusted Services Providers!
                </h1>

                <p>
                  Simba Tasker is Zimbabwe’s leading app designed to connect
                  customers with service providers, tradespeople, and
                  businesses, whether verified or not. Our secure, high-quality
                  & easy-to-use location-based system connects you to the right
                  service provider in need of services.
                </p>
              </div>
              <div className="action-btns mt-4">
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <Link
                      to="https://apps.apple.com/in/app/simbatasker/id6736746247"
                      target="_blank"
                      className="d-flex align-items-center app-download-btn btn btn-white btn-rounded"
                    >
                      <img
                        src={require("../images/ios-down.svg").default}
                        alt="icon"
                      />
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      target="_blank"
                      to="https://play.google.com/store/apps/details?id=com.simbatasker.app&pcampaignid=web_share"
                      className="d-flex align-items-center app-download-btn btn btn-white btn-rounded"
                    >
                      <img
                        src={require("../images/play-store.svg").default}
                        alt="icon"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={6} className="">
              <div className="banner_image">
                <img
                  className="moving_animation"
                  src={require("../images/banner-image1.png")}
                  alt="image"
                  data-aos="fade-left"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="row_am trusted_section pb-0">
        <Container>
          <section className="row_am about_app_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={6}>
                  <div className="about_img">
                    <div className="frame_img">
                      <img
                        className="moving_position_animatin"
                        src={require("../images/about-frame1.png")}
                        alt="image"
                      />
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="about_text">
                    <div className="section_title" data-aos-delay="100">
                      <h2>
                        Creating a network of service providers for customer’s{" "}
                        <span>convenience & peace of mind</span>
                      </h2>
                    </div>

                    <ul
                      className="app_statstic"
                      id="counter"
                      data-aos="fade-in"
                      data-aos-duration="1500"
                    >
                      <li>
                        <div className="icon">
                          <img
                            src={require("../images/app-download.svg").default}
                            alt="image"
                          />
                        </div>
                        <div className="text">
                          <p>
                            <span className="counter-value">
                              {/* {data?.data?.total_users} */}
                              <UserCountdown
                                totalUsers={data?.data?.total_users}
                              />
                            </span>
                            <span></span>
                          </p>
                          <p>App Download</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <img
                            src={require("../images/total-reviews.svg").default}
                            alt="image"
                          />
                        </div>
                        <div className="text">
                          <p>
                            <span className="counter-value">
                              {/* {data?.data?.total_reviews} */}
                              <UserCountdown
                                totalUsers={data?.data?.total_reviews}
                              />
                            </span>
                            <span></span>
                          </p>
                          <p>Total Reviews</p>
                        </div>
                      </li>
                    </ul>

                    <a
                      href="#contact"
                      className="btn puprple_btn"
                      data-aos="fade-in"
                      data-aos-duration="1500"
                    >
                      Contact Us
                    </a>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </Container>
      </section>

      <section
        className="promo-section row_am position-relative overflow-hidden pb-4"
        id="categories"
      >
        <Container>
          <Row>
            <Col lg={12}>
              <div className="section-heading">
                <h2>Simba Tasker Categories</h2>
                <p>
                  Find the type of service provider you’re looking for to get
                  your tasks done quickly and efficiently. At Simba Tasker, a
                  few offered categories include:
                </p>
              </div>
            </Col>
          </Row>
          <div className="screen_slider">
            <OwlCarousel
              className="owl-theme"
              loop
              // margin={10}
              nav={true}
              {...optionsnewslider}
            >
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/pest-control.png")}
                      alt="image"
                    />
                    <p>Pest Control</p>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/gardening-services.png")}
                      alt="image"
                    />
                    <p>Gardening Services</p>
                  </div>
                </div>
              </div>{" "}
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/delivery-services.png")}
                      alt="image"
                    />
                    <p>Delivery Services</p>
                  </div>
                </div>
              </div>{" "}
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/cleaning-services.png")}
                      alt="image"
                    />
                    <p>Cleaning Services</p>
                  </div>
                </div>
              </div>{" "}
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/snow-removal.png")}
                      alt="image"
                    />
                    <p>Snow Removal</p>
                  </div>
                </div>
              </div>{" "}
              <div className="item">
                <div className="screen_frame_img">
                  <div className="categories-box">
                    <img
                      src={require("../images/handyman-services.png")}
                      alt="image"
                    />
                    <p>Handyman Services</p>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </Container>
      </section>

      <section className="row_am modern_ui_section " id="our-mission">
        <Container>
          <Row className="reverse-mobile">
            <Col lg={6}>
              <div className="ui_text">
                <div
                  className="section_title aos-init aos-animate"
                  data-aos-delay="100"
                >
                  <h2>
                    <span className="green_color">Our </span>Mission
                  </h2>
                  <p>
                    Simba Tasker focuses on building a strong and reliable
                    connection between the service provider and the user. We are
                    committed to delivering high-quality services that meet the
                    needs and expectations of our customers more quickly,
                    efficiently, and conveniently.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div
                className="ui_images aos-init aos-animate"
                data-aos="fade-in"
                data-aos-duration="1500"
              >
                <div className="left_img">
                  <img
                    className="moving_position_animatin"
                    src={require("../images/mission.png")}
                    alt="image"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="row_am modern_ui_section " id="our-vision">
        <Container>
          <Row>
            <Col lg={6}>
              <div
                className="ui_images aos-init aos-animate"
                data-aos="fade-in"
                data-aos-duration="1500"
              >
                <div className="left_img">
                  <img
                    className="moving_position_animatin"
                    src={require("../images/our-vision.png")}
                    alt="image"
                  />
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="ui_text">
                <div
                  className="section_title aos-init aos-animate"
                  data-aos-delay="100"
                >
                  <h2>
                    <span className="green_color">Our </span>Vision
                  </h2>
                  <p>
                    Simba Tasker helps to ensure that everyone can access
                    reliable and timely services in their time of need. We want
                    to bring the right service provider to your doorstep to
                    maintain a standard of customer satisfaction through our
                    app.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="row_am how_it_works" id="process">
        <Container>
          <div className="how_it_inner">
            <div className="section_title">
              <h2>
                <span>How To</span> Use Simba Tasker?
              </h2>

              <p className="mb-5">
                We provide a user-friendly application to ease your experience
                while exploring the features.
              </p>
            </div>
            <div className="step_block">
              <ul>
                <li>
                  <div className="step_text">
                    <h4>Welcome to Simba Tasker</h4>

                    <p>
                      Download the App now for your Android or iOS devices and
                      make an account. Follow the instructions given above.
                    </p>
                  </div>
                  <div className="step_number">
                    <h3>01</h3>
                  </div>
                  <div className="step_img">
                    <img src={require("../images/steps_1.png")} alt="image" />
                  </div>
                </li>

                <li>
                  <div className="step_text">
                    <h4>Pick The Best Tasker</h4>

                    <p>
                      Pick an appropriate tasker with better ratings and reviews
                      to perform those specific tasks.
                    </p>
                  </div>
                  <div className="step_number">
                    <h3>02</h3>
                  </div>
                  <div className="step_img">
                    <img src={require("../images/steps_2.png")} alt="image" />
                  </div>
                </li>

                <li>
                  <div className="step_text">
                    <h4>Make Communication</h4>

                    <p>
                      Discuss your task with the service provider and let them
                      start your work up to your wish.
                    </p>
                  </div>
                  <div className="step_number">
                    <h3>03</h3>
                  </div>
                  <div className="step_img">
                    <img src={require("../images/steps_3.png")} alt="image" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>

      <section className="row_am testimonial_section" id="testimonial">
        <Container>
          <div className="section_title">
            <h2>
              Feedback From <span>Our Customers…</span>
            </h2>

            <p>Get to know what people say about us!</p>
          </div>
          <div className="testimonial_block" data-aos="fade-in">
            <div id="testimonial_slider">
              <OwlCarousel
                className="owl-theme"
                loop
                margin={10}
                nav={false}
                dots={true}
                {...optionsslider}
              >
                <div className="item">
                  <div className="testimonial_slide_box">
                    <div className="rating">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="review">
                      “ The tasker helped me clean my house after the house
                      party. ”
                    </p>
                    <div className="testimonial_img">
                      <img
                        src={require("../images/testimonial_user1.png")}
                        alt="image"
                      />
                    </div>
                    <h3>Shayna John</h3>
                    <span className="designation">Careative inc</span>
                  </div>
                </div>

                <div className="item">
                  <div className="testimonial_slide_box">
                    <div className="rating">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="review">
                      “ Simba Tasker helps to find a handyperson by sitting at
                      your home. ”
                    </p>
                    <div className="testimonial_img">
                      <img
                        src={require("../images/testimonial_user2.png")}
                        alt="image"
                      />
                    </div>
                    <h3>Willium Den</h3>
                    <span className="designation">Careative inc</span>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial_slide_box">
                    <div className="rating">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                            fill="#18DF80"
                            stroke="#18DF80"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <p className="review">
                      “ The electrician I found from the app, helped in
                      installing new lights in my studio. ”
                    </p>
                    <div className="testimonial_img">
                      <img
                        src={require("../images/testimonial_user3.png")}
                        alt="image"
                      />
                    </div>
                    <h3>Cyrus Stephen</h3>
                    <span className="designation">Careative inc</span>
                  </div>
                </div>
              </OwlCarousel>
            </div>
            <div className="total_review">
              <div className="rating">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                      fill="#18DF80"
                      stroke="#18DF80"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                      fill="#18DF80"
                      stroke="#18DF80"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                      fill="#18DF80"
                      stroke="#18DF80"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                      fill="#18DF80"
                      stroke="#18DF80"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M8.52917 1L10.8557 5.71326L16.0583 6.4737L12.2938 10.1404L13.1822 15.3205L8.52917 12.8735L3.87614 15.3205L4.76459 10.1404L1 6.4737L6.20266 5.71326L8.52917 1Z"
                      fill="#18DF80"
                      stroke="#18DF80"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <p>5.0 / 5.0</p>
              </div>
              <h3>2578</h3>
            </div>

            <div className="avtar_faces">
              <img
                src={require("../images/avtar_testimonial.png")}
                alt="image"
              />
            </div>
          </div>
        </Container>
      </section>

      <section className="row_am free_app_section mb-0 pb-0" id="getstarted">
        <Container>
          <div
            className="free_app_inner"
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <Row>
              <Col lg={6}>
                <div className="free_text">
                  <div className="section_title">
                    <h2>
                      Download the Simba Tasker App Now, Book An Appointment
                      With Ease!
                    </h2>
                    <p>
                      We wish to improve the quality of your smaller or bigger
                      tasks, saving you valuable time and effort. Book a tasker,
                      assign the task, and get it done with a better experience.
                    </p>
                    <p>Simba Tasker: Your Digital Task Partner!</p>
                  </div>
                  <ul className="app_btn">
                    <li>
                      <Link
                        to="https://apps.apple.com/in/app/simbatasker/id6736746247"
                        target="_blank"
                      >
                        <img
                          src={require("../images/ios-down.svg").default}
                          alt="image"
                        />
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="https://play.google.com/store/apps/details?id=com.simbatasker.app&pcampaignid=web_share"
                        target="_blank"
                      >
                        <img
                          src={require("../images/play-store.svg").default}
                          alt="image"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={6}>
                <div className="free_img">
                  <img
                    src={require("../images/download-screen01.png")}
                    alt="image"
                  />
                  <img
                    className="mobile_mockup"
                    src={require("../images/download-screen02.png")}
                    alt="image"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="contact_page_section mb-4 row_am" id="contact">
        <Container>
          <div className="contact_inner">
            <div className="contact_form">
              <div className="section_title">
                <h2>Ready to get started?</h2>
              </div>
              <Formik
                initialValues={{ name: "", email: "", message: "" }}
                validationSchema={validateYupSchema}
                onSubmit={async (values, { resetForm }) => {
                  console.log(values);
                  try {
                    const data = await dispatch(ContactUs(values));
                    if (data?.payload?.data?.status === 200) {
                      toast.success(data?.payload?.data?.message);
                      resetForm();
                    }
                    console.log(data);
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                {({ values, handleChange, handleSubmit }) => (
                  <Form id="contactForm">
                    <div className="form-group">
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter name"
                        className="form-control"
                        as={Form.Control}
                        onChange={handleChange}
                        value={values.name}
                      />
                      <ErrorMessage name="name" component="div" />
                    </div>
                    <div className="form-group">
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter email"
                        className="form-control"
                        as={Form.Control}
                        onChange={handleChange}
                        value={values.email}
                      />
                      <ErrorMessage name="email" component="div" />
                    </div>
                    <div className="form-group">
                      <Form.Control
                        as="textarea"
                        className="form-control"
                        name="message"
                        placeholder="Message"
                        onChange={handleChange}
                        value={values.message}
                      ></Form.Control>
                    </div>
                    <ErrorMessage name="message" component="div" />

                    <div className="form-group mb-0">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn puprple_btn"
                      >
                        SEND MESSAGE
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>

            <div className="contact_info">
              <div className="section_title">
                <h2 className="mb-4">Want To Reach Out?</h2>
              </div>
              <ul className="contact_info_list">
                <li>
                  <div className="img">
                    <img
                      src={require("../images/location_icon.svg").default}
                      alt="image"
                    />
                  </div>
                  <div className="text">
                    <span>Company Location</span>
                    <p>Australia </p>
                  </div>
                </li>
                <li>
                  <div className="img">
                    <img
                      src={require("../images/message_icon.svg").default}
                      alt="image"
                    />
                  </div>
                  <div className="text">
                    <span>Email Address</span>
                    <Link to="mailto:info@simbatasker.com">
                      info@simbatasker.com
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  );
}
